import { Modal } from "react-bootstrap";
import "../PopupModal.css";
import styles from "../PopupModal.module.css";
import { Urls } from "../../../../Urls";

const ControlledPopupModal = ({
  isOpen,
  onClose,
  content,
  className = "",
  dialogClassName = "modal-dialog",
  backdrop = false,
  size = "lg",
  closeButtonNeeded = true,
  closeButtonId = "close_contactus",
  title = "",
  subtitle = "",
  showLogo = false,
  overflowStyles = {},
  variant = "",
  titleSize = "lg", // sm, md, lg, xl
}) => {
  const titleSizeClass =
    styles[`titleSize_${titleSize}`] || styles.titleSize_md;

  return (
    <Modal
      size={size}
      show={isOpen}
      onHide={onClose}
      className={className}
      dialogClassName={`${dialogClassName} d-flex justify-content-center ${
        variant === "popover" ? styles.popover_style : ""
      }`}
      animation={false}
      style={overflowStyles}
      backdrop={backdrop}
      keyboard={true}
    >
      <Modal.Header>
        <div className={styles.modalHeader}>
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            {showLogo && (
              <div>
                <img
                  src={Urls.LorriLogoLogin}
                  alt="Logo"
                  style={{ height: "32px", objectFit: "contain" }}
                  width="73"
                />
              </div>
            )}
            <div className="d-flex flex-column justify-content-end">
              <div className={`${styles.title} ${titleSizeClass}`}>{title}</div>
              {subtitle && (
                <div
                  className="text-muted mt-1 font-italic"
                  style={{ fontSize: "14px" }}
                >
                  {subtitle}
                </div>
              )}
            </div>
          </div>

          {closeButtonNeeded && (
            <button
              id={closeButtonId}
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={onClose}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
    </Modal>
  );
};

export default ControlledPopupModal;
